/*global google*/
import React, { useEffect } from 'react';
import { GoogleMap, GoogleMapProps, withGoogleMap, withScriptjs } from 'react-google-maps';

interface IProps {
  map: any;
  bounds?: any[];
  onZoomChanged?: () => void;
}

const MapBase: React.FC<GoogleMapProps & IProps> = ({ map, bounds, onZoomChanged, children, ...props }) => {
  useEffect(() => {
    if (bounds) {
      const mapBounds = new google.maps.LatLngBounds();
      bounds.map((point) => mapBounds.extend(point));
      map.current.fitBounds(mapBounds);
    }
  }, [map, bounds]);
  return (
    <GoogleMap
      ref={map}
      defaultZoom={props.defaultZoom}
      defaultCenter={props.defaultCenter}
      options={{
        mapTypeControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT,
        },
        fullscreenControl: false,
        streetViewControl: false,
      }}
      onZoomChanged={onZoomChanged}
      {...props}
    >
      {children}
    </GoogleMap>
  );
};

MapBase.defaultProps = {
  defaultZoom: 5,
  defaultCenter: {
    lat: 38.6406812,
    lng: -106.1094301,
  },
};

export default withScriptjs(withGoogleMap(MapBase));
